import React from "react";
import { Link } from "react-router-dom";
import { Scissors } from "lucide-react";

export default function NotFound() {
  return (
    <div data-testid="notfound-page" className="min-h-screen flex flex-col items-center justify-center px-5 text-center pt-20">
      <Scissors className="w-12 h-12 text-[#D4AF37] mb-6" />
      <h1 className="font-display text-8xl sm:text-9xl tracking-tighter text-[#D4AF37]">404</h1>
      <p className="text-2xl font-display mt-2">This chair doesn't exist.</p>
      <p className="text-gray-400 mt-3 max-w-md">The page you're looking for has been cut. Let's get you back to the shop.</p>
      <Link to="/" className="mt-8 px-8 py-3 rounded-full bg-[#D4AF37] text-black font-medium hover:bg-[#F3E5AB] transition-colors duration-300">
        Back Home
      </Link>
    </div>
  );
}
